var React = require('react');
var lodash = require('lodash').noConflict();
var labels = require('MemberJoinLabels');
var ChangeStepButtons = require('../ChangeStepButtons/changeStepButtons.jsx');
var { $form } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');

var applicationData = require('ApplicationTypes');

class Step1 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            workLocation: ''
        }

        this.fieldHierarchy = ['workLocation', 'workLocationChild', 'workLocationGrandChild', 'workLocationGrandChildSuboption'];

        this.bindFunctions();
    }

    bindFunctions() {
        this.prevStepValid = this.prevStepValid.bind(this);
        this.nextStepValid = this.nextStepValid.bind(this);

        this.buildWorkLocationTree = this.buildWorkLocationTree.bind(this);
        this.clearNodeAndDescendantsData = this.clearNodeAndDescendantsData.bind(this);
        this.getSingleNodeMarkup = this.getSingleNodeMarkup.bind(this);
        this.getAllChildrenMarkup = this.getAllChildrenMarkup.bind(this);

        this.getChildrenData = this.getChildrenData.bind(this);
        this.goNextStep = this.goNextStep.bind(this);
        this.resetSelections = this.resetSelections.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    componentDidMount() {
        // if we loaded an appType from XConnect, set it for Step 1
        if (this.props.appState.appType) {
            this.props.updateStepState('appType', this.props.appState.appType);
        }
    }

    prevStepValid() {
        return this.props.appState.currentStep > 1 || this.props.appState.debugMode;
    }

    nextStepValid() {
        return (this.props.appState.currentStep < 6 && this.props.stepState.appType) || this.props.appState.debugMode;
    }

    resetSelections() {
        this.clearNodeAndDescendantsData('workLocation');

        this.props.updateStepState('appType', '');
        this.props.updateStepState('productType', '');
        this.props.updateStepState('rateType', '');
        this.props.updateStepState('isMilitary', false);
        this.props.updateStepState('isGovernmentEmployee', false);
        this.props.updateStepState('isInternational', false);
        this.props.updateStepState('isPdf', false);
        this.props.updateStepState('pdfLink', '');
    }

    goNextStep(event) {
        this.props.updateApplicationState('appType', this.props.stepState.appType);
        this.props.updateApplicationState('productType', this.props.stepState.productType);
        this.props.updateApplicationState('rateType', this.props.stepState.rateType);
        this.props.updateApplicationState('isMilitary', this.props.stepState.isMilitary);
        this.props.updateApplicationState('isGovernmentEmployee', this.props.stepState.isGovernmentEmployee);
        this.props.updateApplicationState('isInternational', this.props.stepState.appType.indexOf('INT') === 0);
        this.props.updateApplicationState('isPdf', this.props.stepState.isPdf);
        this.props.updateApplicationState('pdfLink', this.props.stepState.pdfLink);

        this.props.goToStep(event, 2);
    }

    clearNodeAndDescendantsData(nodeName) {
        var hierarchyPosition = lodash.findIndex(this.fieldHierarchy, x => x === nodeName);
        for (var i = hierarchyPosition; i < this.fieldHierarchy.length; i++) {
            this.props.updateStepState(this.fieldHierarchy[i], '');
        }
    }

    handleCheckboxChange(event) {
        if (!event.target.checked) {
            this.clearNodeAndDescendantsData(event.target.name);
        } else {
            this.props.updateStepState(event.target.name, event.target.value);
        }

        if (!event.target.checked && event.target.dataset.parentkey) {
            const workLocationData = lodash.find(applicationData.workLocation.children, x => x.value === this.props.stepState.workLocation);
            const workLocationChildData = lodash.find(workLocationData.children, x => x.value === this.props.stepState.workLocationChild);
            const fallbackData = lodash.find(workLocationChildData.children, x => x.value === this.props.stepState.workLocationGrandChild);

            this.props.updateStepState('appType', fallbackData.appType);
            this.props.updateStepState('productType', fallbackData.productType);
            this.props.updateStepState('rateType', fallbackData.rateType);
            this.props.updateStepState('isMilitary', fallbackData.isMilitary);
            this.props.updateStepState('isGovernmentEmployee', fallbackData.isGovernmentEmployee);
            this.props.updateStepState('isPdf', fallbackData.isPdf);
            this.props.updateStepState('pdfLink', fallbackData.pdfLink);
        } else {
            this.props.updateStepState('appType', event.target.checked && event.target.dataset.apptype ? event.target.dataset.apptype : '');
            this.props.updateStepState('productType', event.target.checked && event.target.dataset.producttype ? event.target.dataset.producttype : '');
            this.props.updateStepState('rateType', event.target.checked && event.target.dataset.ratetype ? event.target.dataset.ratetype : '');
            this.props.updateStepState('isMilitary', event.target.checked && event.target.dataset.ismilitary === "true");
            this.props.updateStepState('isGovernmentEmployee', event.target.checked && event.target.dataset.isgovernmentemployee === "true");
            this.props.updateStepState('isPdf', event.target.checked && event.target.dataset.ispdf === "true");
            this.props.updateStepState('pdfLink', event.target.checked && event.target.dataset.pdflink ? event.target.dataset.pdflink : '');
        }
    }

    getSingleNodeMarkup(data, fieldName) {
        const selected = this.props.stepState[fieldName] === data.value;
        return <div className={fieldName}>
            <input type="checkbox"
                id={data.value}
                name={fieldName}
                value={data.value}
                onChange={this.handleCheckboxChange}
                data-apptype={data.appType}
                data-producttype={data.productType}
                data-ratetype={data.rateType}
                data-ismilitary={data.isMilitary}
                data-isgovernmentemployee={data.isGovernmentEmployee}
                data-ispdf={data.isPdf}
                data-pdflink={data.pdfLink ? data.pdfLink.Url : ''}
                checked={selected} />
            <label className={selected ? 'selected' : ''} htmlFor={data.value}>{data.label}</label></div>;
    }

    getAllChildrenMarkup(arrayOfChildren, fieldName, parentKey) {
        return arrayOfChildren.map(function (child, index) {
            const selected = this.props.stepState[fieldName] === child.value;
            var infoModalContent = this.props.getInfoModalContent(child.rateType);
            const infoIcon = fieldName == 'workLocationGrandChildSuboption' && child.rateType && this.props.hasModalInfo(child.rateType) ? <span className={"get-info"} onClick={() => { return this.props.showInfoModal(child.rateType) }}>{infoModalContent ? infoModalContent.infoIconLabel : ''}</span> : null;

            return <div className={fieldName} key={index}>
                <input type="checkbox"
                    id={child.value}
                    name={fieldName}
                    value={child.value}
                    onChange={this.handleCheckboxChange}
                    data-apptype={child.appType}
                    data-producttype={child.productType}
                    data-ratetype={child.rateType}
                    data-ismilitary={child.isMilitary}
                    data-isgovernmentemployee={child.isGovernmentEmployee}
                    data-ispdf={child.isPdf}
                    data-pdflink={child.pdfLink ? child.pdfLink.Url : ''}
                    checked={this.props.stepState[fieldName] === child.value}
                    data-parentkey={parentKey}/>
                <label className={selected ? 'selected' : ''} htmlFor={child.value}>{child.label}</label>{infoIcon}</div>;
        }.bind(this));
    }

    getChildrenData(array, valueKey) {
        var location = lodash.find(array, x => x.value === valueKey);
        return location ? location.children : null;
    }

    buildWorkLocationTree() {
        if (this.props.stepState.workLocation) {

            const workLocationData = lodash.find(applicationData.workLocation.children, x => x.value === this.props.stepState.workLocation);
            const workLocation = this.getSingleNodeMarkup(workLocationData, "workLocation");

            if (this.props.stepState.workLocationChild) {

                const workLocationChildData = lodash.find(workLocationData.children, x => x.value === this.props.stepState.workLocationChild);
                const workLocationChild = this.getSingleNodeMarkup(workLocationChildData, "workLocationChild");

                if (this.props.stepState.workLocationGrandChild) {

                    const workLocationGrandChildData = lodash.find(workLocationChildData.children, x => x.value === this.props.stepState.workLocationGrandChild);
                    const workLocationGrandChild = this.getSingleNodeMarkup(workLocationGrandChildData, "workLocationGrandChild");
                    const workLocationGrandChildSuboptions = this.getAllChildrenMarkup(workLocationGrandChildData.children, "workLocationGrandChildSuboption", workLocationGrandChildData.value);

                    return <div className={"step1"}>{workLocation}{workLocationChild}{workLocationGrandChild}{workLocationGrandChildSuboptions}</div>;
                } else {

                    const workLocationGrandChildren = this.getAllChildrenMarkup(workLocationChildData.children, "workLocationGrandChild");
                    return <div className={"step1"}>{workLocation}{workLocationChild}{workLocationGrandChildren}</div>;
                }
            } else {

                const workLocationChildren = this.getAllChildrenMarkup(workLocationData.children, "workLocationChild");
                return <div className={"step1"}>{workLocation}{workLocationChildren}</div>;
            }
        } else {

            const workLocations = this.getAllChildrenMarkup(applicationData.workLocation.children, "workLocation");
            return <div className={"step1"}>{workLocations}</div>;
        }
    }

    render() {
        const workLocationTree = this.buildWorkLocationTree();

        return <div className={"step-1-container"}>
            <$form onSubmit={this.goNextStep} ref={c => { this.form = c }}>
                <h3>{labels.step1.iAm}</h3>
                {workLocationTree}

                <ChangeStepButtons
                    disableUI={this.props.appState.disableUI}
                    nextStepValid={this.nextStepValid}
                    prevStepValid={this.prevStepValid}
                    isPdf={this.props.stepState.isPdf}
                    pdfLink={this.props.stepState.pdfLink}
                    goPrevStep={this.props.goPrevStep}
                    currentStep={this.props.appState.currentStep} />
            </$form>
        </div>;
    }
}

module.exports = Step1;
